export const hideSubscriptionModal = () => {
  return {
    type: 'HIDE_SUBSCRIPTION_MODAL',
    payload: {show: false}
  }
}

export const showSubscriptionModal = () => ({
  type: 'SHOW_SUBSCRIPTION_MODAL',
  payload: {show: true}
})
